import cx from 'clsx';
import React, { CSSProperties } from 'react';
import { isHeadless } from './utils';

export interface IntersectionObserverWrapperPropTypes {
  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  dataTestId?: string;
  loadingClassName?: string;
}

const IntersectionObserverWrapper: React.FC<IntersectionObserverWrapperPropTypes> = ({
  children,
  className,
  style,
  dataTestId,
  loadingClassName,
}) => {
  const [intersected, setIntersected] = React.useState<boolean>(false);
  const ref: any = React.useRef();
  React.useEffect(() => {
    if (!('IntersectionObserver' in window) || !isHeadless) {
      return setIntersected(true);
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIntersected(true);
        }
      },
      { threshold: 0.01 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (observer && observer.disconnect) observer.disconnect();
    };
  }, [ref]);

  return (
    <div
      data-testid={dataTestId || ''}
      ref={ref}
      className={cx(className, !intersected && loadingClassName)}
      style={style || {}}
    >
      {intersected ? children : null}
    </div>
  );
};

export default IntersectionObserverWrapper;
